import enumPart from '@data/enumPart';

// util
import objectHelper from '@util/objectHelper';

let couponBizTypeEnum = objectHelper.merge(enumPart, {

    VOICE: {
        code: 1,
        title: '语音直播'
    },
    COURSE: {
        code: 2,
        title: '视频课程'
    },
    ACCOUNT: {
        code: 3,
        title: '充值'
    },
    VOD: {
        code: 4,
        title: '点播课程'
    },
    OPEN_VIP: {
        code: 10,
        title: '开通VIP'
    },
    RENEW_VIP: {
        code: 11,
        title: '续费VIP'
    },
    DATUM: {
        code: 26,
        title: '资料'
    },
    PAY_QR: {
        code: 33,
        title: '支付二维码支付'
    }

});

export default couponBizTypeEnum;
